// index.js
import './bootstrap'
import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        el: '#calendar',
        components: {
            App
        }
    })


    // Add classes that used to be there 

    const toolbarChunks = document.querySelectorAll('.fc-header-toolbar .fc-toolbar-chunk');

    if (toolbarChunks.length >= 3) {
        // Add the fc-left class to the first chunk
        toolbarChunks[0].classList.add('fc-left');

        // Add the fc-center class to the second chunk
        toolbarChunks[1].classList.add('fc-center');

        // Add the fc-right class to the third chunk
        toolbarChunks[2].classList.add('fc-right');
    }
})



